import { ShieldCheck, Phone, MapPin, User, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE, SITE, NRW_CITIES, OTHER_CITIES, COMPANY } from "@/lib/siteConfig";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#040F1B] text-slate-300 border-t border-white/5"
    >
      <div className="ss-container py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--ss-gold)] text-[var(--ss-navy)]">
                <ShieldCheck className="h-5 w-5" strokeWidth={2.5} />
              </span>
              <span className="font-display font-bold text-lg text-white">
                SecurityStaging<span className="text-[var(--ss-gold)]">.de</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed max-w-md">
              {SITE.tagline}. Wir sichern leerstehende Immobilien mit professioneller Funk-Alarmtechnik – deutschlandweit, spurlos, als Premium-Verkaufsargument.
            </p>

            <div className="mt-5 text-xs text-slate-400 space-y-1">
              <div className="flex items-center gap-2">
                <User className="h-3.5 w-3.5 text-slate-500" />
                <span>Inhaber: <span className="text-slate-300">{COMPANY.owner}</span></span>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="h-3.5 w-3.5 text-slate-500 mt-0.5" />
                <address className="not-italic text-slate-300 leading-relaxed">
                  {COMPANY.name}<br />
                  {COMPANY.street}<br />
                  {COMPANY.postalCode} {COMPANY.city}
                </address>
              </div>
            </div>
          </div>

          <div>
            <div className="text-white font-display font-semibold text-sm uppercase tracking-widest">Kontakt</div>
            <a
              href={`tel:${PHONE.tel}`}
              className="mt-4 inline-flex items-center gap-2 font-semibold text-[var(--ss-gold)] hover:text-white transition"
              data-testid="footer-phone-cta"
            >
              <Phone className="h-4 w-4" />
              {PHONE.display}
            </a>
            <div className="mt-2 text-xs text-slate-400">{PHONE.hours}</div>
            <a
              href={`mailto:${COMPANY.email}`}
              className="mt-3 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-[var(--ss-gold)] transition"
              data-testid="footer-email"
            >
              <Mail className="h-4 w-4" />
              {COMPANY.email}
            </a>
            <div className="mt-4 flex items-center gap-2 text-sm">
              <MapPin className="h-4 w-4 text-slate-500" />
              Deutschlandweit im Einsatz
            </div>
          </div>

          <div>
            <div className="text-white font-display font-semibold text-sm uppercase tracking-widest">Regionen</div>
            <div className="mt-4">
              <div className="text-[10px] uppercase tracking-widest font-semibold text-[var(--ss-gold)]/90">NRW (Schwerpunkt)</div>
              <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1.5 text-sm text-slate-300">
                {NRW_CITIES.slice(0, 15).map((c) => (
                  <span key={c}>{c}</span>
                ))}
              </div>
            </div>
            <div className="mt-4">
              <div className="text-[10px] uppercase tracking-widest font-semibold text-slate-400">Bundesweit</div>
              <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1.5 text-sm text-slate-400">
                {OTHER_CITIES.map((c) => (
                  <span key={c}>{c}</span>
                ))}
              </div>
            </div>
            <div className="mt-3 text-xs text-slate-500">
              Und viele weitere Städte &amp; Landkreise.
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {year} {COMPANY.name} · {COMPANY.owner}. Alle Rechte vorbehalten.</div>
          <div className="flex items-center gap-5 flex-wrap">
            <Link to="/impressum" className="hover:text-white transition" data-testid="footer-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition" data-testid="footer-datenschutz">Datenschutz</Link>
            <Link to="/agb" className="hover:text-white transition" data-testid="footer-agb">AGB</Link>
            <button
              type="button"
              onClick={() => typeof window !== "undefined" && window.__ssOpenCookieSettings && window.__ssOpenCookieSettings()}
              className="hover:text-white transition"
              data-testid="footer-cookie-settings"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
